export default __webpack_public_path__ + "static/media/Brigand's Straps of the Wicked Hearth.c39c5668.jpg";